import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MedicaidDirectTransition = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACTS_MedicaidDirectTransition' className='file-pdf-document'>
         <div className='file-template'>


            <h3>
               Request to Stay in NC Medicaid Direct (Fee for Service) and LME-MCO: Provider Form
            </h3>
            <h4>
               What is this form for?
            </h4>
            <p className='w-750'>
               This form is for you to request for an individual with Medicaid to stay in, or move to, NC Medicaid  Direct (formerly known as Fee-for-Service or traditional Medicaid) and an Local Management Entity Managed Care Organization (LME-MCO). While physical health services are the same for all  individuals with Medicaid, some services for people with an intellectual/developmental disability  (I/DD), mental illness, traumatic brain injury, or substance use disorder are only available in NC  Medicaid Direct and through the LME-MCOs. It may benefit an individual to stay in NC Medicaid  Direct and their LME-MCO if they need these services. These services are not in the new Standard  Health Plans. This form can be filled out by a doctor, therapist or other I/DD, Mental Health, or  Substance Use Disorder provider of the person enrolled in NC Medicaid.
            </p>
            <p className='w-750'>
               Send this form to NC Medicaid by mail, fax, or online:
            </p>
            <p className='w-750'>
               Mail Fax Online <br />
               NC Medicaid 1-833-898-9655 ncmedicaidplans.gov PO Box 613 <br />
               Morrisville, NC 27560
            </p>
            <h4>
               What happens next?
            </h4>
            <p className='w-750'>
               NC Medicaid will review the information on the form and will contact the doctor, therapist or other  behavioral health provider who completes this form if more information is needed.
            </p>
            <p className='w-750'>
               If the request is approved, we will send a letter to the individual with Medicaid to let them know that  they will continue getting, or begin getting, their Medicaid services through NC Medicaid Direct and an  LME-MCO.
            </p>
            <p className='w-750'>
               If the request is not approved, we will send a letter to the individual with Medicaid to let them know  that they will continue to be enrolled, in one of the new Health Plans. The letter will also tell them how  they can appeal if they do not agree with our decision.
            </p>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbRequest" name="cbRequest" className='add-only' value="Request" />   Request for Substance Abuse Comprehensive Outpatient Treatment (SACOT)
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbRequest1" name="cbRequest1" className='add-only' value="Request1" />   Request for Substance Abuse Intensive Outpatient Program (SAIOP)
            </p>
            <h4>
               1. Beneficiary Demographic Information
            </h4>
            <p className='w-750'>
               Fill out the beneficiary demographic information and guardian/legally responsible person  contact information.
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Beneficiary Name </span>
                      </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Date of Birth </span>
                       </td>
                  <td className='w-250'>
                     <span className='eleHeader'>NC Medicaid ID Number</span>
                     </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='small'>(Last, First, M.I.)</span>
                     </td>
                  <td className='w-250'>
                      </td>
                  <td className='w-250'>
                    </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtBeneficiaryName1" name="txtBeneficiaryName1" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="date" id="txtDateBirth" name="txtDateBirth" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtMedicaid1" name="txtMedicaid1" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Guardian/Legally Responsible Person </span>
                     <input type="text" id="txtBeneficiaryName" name="txtBeneficiaryName" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Guardian/Legally Responsible  Person Phone Number</span>
                     <input type="text" id="txtGuardianLegally" name="txtGuardianLegally" className='add-only' />
                  </td>
               </tr>
            </table>
            <h4>
               2. Provider Submitting this Form
            </h4>
            <p className='w-750'>
               Fill out the provider information
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Provider Name  </span>
                     </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Telephone Number</span>
                        </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Provider Agency </span>
                      </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='small'>(Last, First, M.I.)</span>
                  </td>
                  <td className='w-250'>
                  </td>
                  <td className='w-250'>
                     <span className='small'>(if Applicable)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtProviderName" name="txtProviderName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtTelephoneNumber" name="txtTelephoneNumber" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtMedicaid" name="txtMedicaid" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>NPI/Provider Identifier</span>
                     <input type="text" id="txtProviderIdentifier" name="txtProviderIdentifier" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Provider email</span>
                     <input type="text" id="txtProviderEmail" name="txtProviderEmail" className='add-only' />
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
            </table>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-
               870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <h3>
               3. Reason for Submitting Request
            </h3>
            <p className='w-750'>
               Beneficiaries may be eligible to stay in NC Medicaid Direct and their LME-MCO if they meet one of the criteria below. Check all reasons that apply and provide the requested information:
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid1" name="cbMedicaid1" className='add-only' value="Medicaid1" />
               Has used, or has a current need for, a Medicaid service that is only available through NC Medicaid Direct and an LME-MCO or a State-funded service. A full list of Medicaid services only available through NC Medicaid Direct and the LME-MCOs and State funded services is attached to this form. Please note the service(s) needed.
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid2" name="cbMedicaid2" className='add-only' value="Medicaid2" />
               Has an intellectual or developmental disability (I/DD), serious mental illness, serious emotional disturbance, qualifying substance use disorder, or is a child aged 0-3 with or at risk for, developmental delay or disability. Please provide the DSM 5 or ICD 10 Diagnosis Code/Description and the functional impairment related to the diagnosis:
            </p>
            <p className='w-750'>
               <span className='eleHeader'>ICD 10 Diagnosis Code</span>
               <textarea id="txtDiagnosisCode11" name="txtDiagnosisCode11" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Description</span>
               <textarea id="txtDescription12" name="txtDescription12" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Related Functional Impairment</span>
               <textarea id="txtDescription13" name="txtDescription13" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid3" name="cbMedicaid3" className='add-only' value="Medicaid3" />
               Has survived a traumatic brain injury and is receiving traumatic brain injury services or has a traumatic brain injury that is otherwise a knowable fact. Please provide the ICD 10Diagnosis Code/Description and the functional impairment related to the diagnosis:
            </p>
            <p className='w-750'>
               <span className='eleHeader'>ICD 10 Diagnosis Code</span>
               <textarea id="txtDiagnosisCode1" name="txtDiagnosisCode1" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Description</span>
               <textarea id="txtDescription2" name="txtDescription2" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Related Functional Impairment</span>
               <textarea id="txtDescription3" name="txtDescription3" className='add-only'></textarea>
            </p>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-
               870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid5" name="cbMedicaid5" className='add-only' value="Medicaid5" />
               Has had one involuntary commitment to a State Facility within the past 18 months.
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid6" name="cbMedicaid6" className='add-only' value="Medicaid6" />
               Has had two or more of the following within the past 18 months:
            </p>
            <ul>
               <li>
                  psychiatric hospitalizations
               </li>
               <li>
                  visits to the emergency department due to a behavioral health diagnosis use of behavioral health crisis services (Mobile Crisis Management, Facility Based Crisis Services for Children and Adolescents, Professional Treatment Services in Facility Based Crisis Program)
               </li>
            </ul>
            <p className='w-750'>
               Please provide facility name and date of service below:
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Facility/Agency Name</span>
                     <input type="text" id="txtFacilityAgency1" name="txtFacilityAgency1" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Date(s) of Service</span>
                     <input type="date" id="txtDateService1" name="txtDateService1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="text" id="txtFacilityAgency2" name="txtFacilityAgency2" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="date" id="txtDateService2" name="txtDateService2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="text" id="txtFacilityAgency3" name="txtFacilityAgency3" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="date" id="txtDateService3" name="txtDateService3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="text" id="txtFacilityAgency4" name="txtFacilityAgency4" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="date" id="txtDateService4" name="txtDateService4" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid7" name="cbMedicaid7" className='add-only' value="Medicaid7" />
               Other reason the beneficiary should remain in NC Medicaid Direct and his/herLME-MCO
            </p>
            <p className='w-750'>
               (please describe).
               <textarea id="txtPerformancDescribe" name="txtPerformancDescribe" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <input type="checkbox" id="cbMedicaid8" name="cbMedicaid8" className='add-only' value=" Medicaid8" />
               Optional: Please check if the beneficiary is a youth involved in the juvenile justice system. (Note: Juvenile Justice system involvement is a sign that a beneficiary has high support needs for their mental illness, substance use disorder, I/DD or traumatic brain injury).
            </p>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-
               870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <h4>
               4. Provider Signature
            </h4>
            <p className='w-750'>
               I attest that the information presented in this form is accurate to the best of my knowledge. This request is being submitted for the benefit of the beneficiary and not for the benefit of the beneficiary's enrolled health plan or service provider. I understand this form may be subject to audit.
            </p>
            <table>
               <tr>
                  <td className='signature w-400'>
                     &nbsp;
                  </td>
                  <td className='signature w-350'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-400">
                     Signature
                  </td>
                  <td className="small w-350">
                     Date
                  </td>
               </tr>
               <tr>
                  <td className='signature w-400'>
                     &nbsp;
                  </td>
                  <td className='signature w-350'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-400">
                     Printed Name
                  </td>
                  <td className="small w-350">
                     Plan/Provider Affiliation
                  </td>
               </tr>
            </table>
            <h4>
               5. Care Coordinator/Care Manager Signature
            </h4>
            <p className='w-750'>
               I attest that the information presented in this form is accurate to the best of my knowledge. This request is being submitted for the benefit of the beneficiary and not for the benefit of the beneficiary's enrolled health plan. I understand this form may be subject to audit.
            </p>
            <table>
               <tr>
                  <td className='signature w-400'>
                     &nbsp;
                  </td>
                  <td className='signature w-350'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-400">
                     Signature
                  </td>
                  <td className="small w-350">
                     Date
                  </td>
               </tr>
               <tr>
                  <td className='signature w-400'>
                     &nbsp;
                  </td>
                  <td className='signature w-350'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-400">
                     Printed Name
                  </td>
                  <td className="small w-350">
                     Plan/Provider Affiliation
                  </td>
               </tr>
            </table>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-
               870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
            <h4>
               6. Beneficiary Attestation:
            </h4>
            <p className='w-750'>
               <span className='eleHeader'>Have the beneficiary (or legally responsible person) read and sign the beneficiary attestation.</span>
               <input type="radio" id="rbBeneficiary_Yes" name="rbBeneficiary" className='add-only' value="1" /> Yes&nbsp;
               <input type="radio" id="rbBeneficiary_No" name="rbBeneficiary" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               By signing below, I acknowledge that I am requesting to remain or be moved to fee-for service Medicaid, referred to as NC Medicaid Direct, rather than be enrolled in a Standard Health Plan. I have been fully informed of the differences between NC Medicaid Direct and a Standard Health Plan. I acknowledge that this request will be considered by NC Medicaid or its agent and may be denied based upon my individual circumstances.
            </p>
            <p className='w-750'>
               By signing below, I am agreeing that NC Medicaid may contact the doctor, therapist or other behavioral health provider listed above to obtain medical records, which may include records of the following: intellectual or developmental disability (IDD), mental illness, traumatic brain injury, or substance use disorder. I expressly consent to NC Medicaid receiving any or all such records.
            </p>
            <p className='w-750'>
               I understand that if this request is approved, I will remain in or be moved to NC Medicaid Direct and my LME-MCO. If I have been assigned to a Standard Health Plan, I understand that I will no longer be enrolled in that plan.
            </p>
            <table>
               <tr>
                  <td className='signature w-500'>
                     &nbsp;
                  </td>
                  <td className='signature w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-500">
                     Signature of Person Enrolled in NC Medicaid Date Or Legally Responsible Person
                  </td>
                  <td className="small w-250">
                     Date
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='signature w-750'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-750">
                     Printed Name
                  </td>
               </tr>
            </table>
            <h4>
               Questions?
            </h4>
            <p className='w-750'>
               We can help. Go to ncmedicaidplans.gov. Use the "chat" tool on the website. Or call us at 1-833-
               870- 5500 (TTY: 1-833-870-5588), 7 a.m. to 8 p.m., 7 days a week.
            </p>
         </div>
      </form>

   )
}  
